import { CreateLocationDTO, LocationType, UpdateLocationDTO } from 'types/Location'

import { httpClient } from './clients/httpClient'

export const createLocation = async (locationData: CreateLocationDTO): Promise<LocationType> => {
    try {
        const { data } = await httpClient.post<LocationType>('/locations', locationData)
        return data
    } catch (error: any) {
        console.error('Error creating location:', error.response?.data || error.message)
        throw new Error('Failed to create location')
    }
}

export const getLocations = async (searchTerm = '', isAdmin = false, partnerId?: string): Promise<LocationType[]> => {
    try {
        const basePath = isAdmin ? '/locations/admin' : '/locations'
        const params: any = { search: searchTerm }

        if (isAdmin && partnerId) {
            params.partnerId = partnerId
        }

        const { data } = await httpClient.get<LocationType[]>(basePath, { params })
        return data
    } catch (error) {
        console.error('Failed to fetch locations:', error)
        throw new Error('Failed to fetch locations')
    }
}

export const getLocationById = async (id: string): Promise<LocationType> => {
    try {
        const { data } = await httpClient.get(`/locations/admin/${id}`)
        return data.location
    } catch (error: any) {
        console.error('Error fetching location by ID:', error.response?.data || error.message)
        throw new Error('Failed to fetch location by ID')
    }
}

export const updateLocation = async (id: string, locationData: UpdateLocationDTO, partnerId?: string): Promise<void> => {
    try {
        const config = partnerId ? { params: { partnerId } } : {}

        await httpClient.put(`/locations/${id}`, locationData, config)
    } catch (error: any) {
        console.error('Error updating location:', error.response?.data || error.message)
        throw new Error('Failed to update location')
    }
}

export const deleteLocation = async (id: string): Promise<void> => {
    try {
        await httpClient.delete(`/locations/${id}`)
    } catch (error: any) {
        console.error('Error deleting location:', error.response?.data || error.message)
        throw new Error('Failed to delete location')
    }
}
